const BASIC = '/inventory';
const BASIC_V1 = '/v1/ext/inventory';

export const GET_PRODUCT_INVENTORY_API = `${BASIC}/products`;
export const GET_SESSION_INVENTORY_API = `${BASIC}/sessions`;
export const GET_PRODUCT_INVENTORY_SHARE_API = `${BASIC}/products/share`;
export const GET_PRODUCT_BY_SHARE_CODE_API = `${BASIC_V1}/products`;
export const POST_SHARE_FILTER_RESULT_API = `${BASIC}/products/share`;
export const GET_PROJECT_CMS_API = `/projects`;
export const GET_PROJECT_ITEM_CMS_API = `/project-items`;
export const GET_FLOOR_CMS_API = `/floors`;
export const GET_PROJECT_CHILD_ITEM_CMS_API = `/inventory/products/get-child-items`;
export const GET_AGENT_ACCOUNT_API = `/v1/integ/users/get-users-allow-sell-rent-chp`;
export const GET_SESSION_API = `${BASIC}/sessions`;
export const GET_SESSION_DETAIL_API = `${BASIC}/sessions/by-code`;
export const GET_USER_CONTACT_CMS_API = '/user-contacts';
export const GET_TERM_OF_CONTRACT_API = '/v1/ext/rentable/contract-categories';
export const GET_FEATURE_CMS_API = `features`;
